<template>
  <footer>
    <div class="layout">
      <ul class="f-ul">
        <li>
          <div class="f-logo">
            <figure><img src="@/assets/images/common/MIMIO_B.I.svg" alt="" style="width: 76px; height: 21px;"></figure>
          </div>
        </li>
        <li>
          <div class="f-content">
            <div class="f-content-sub-wrap">
              <span class="f-txt">+82-(0)10-2132-5634 | hello@article21.co.kr</span>
              <span class="footer-link"><a href="https://article21.co.kr/" target="_blank" rel="noopener noreferrer">아티클21 홈페이지</a></span>
            </div>
            <span class="f-txt">Work Hours 10:00-18:00 Weekdays (Excluding 12:00-13:00)</span>
          </div>
          <div class="f-content-2">
            <span class="f-txt">© 2024. ARTICLE21 Corp. All rights reserved.</span>
            <div class="f-link">
              <span class="footer-link"><a href="/terms">Terms of Use</a></span>
              <span class="footer-link"><a href="/privacy">Privacy Policy</a></span>
              <span class="footer-link" :class="{ active: showDetails }" @click="toggleDetailsPc">More Details</span>
            </div>
          </div>
        </li>
        <li :class="{ hidden: !showDetails }" class="transition-area">
          <address>
            <ul class="f-info">
              <li>
                <span class="f-title">CEO</span>
                <span class="f-txt">Ahrum Oh</span>
              </li>
              <li>
                <span class="f-title">PIC</span>
                <span class="f-txt">Jihyeon Kim</span>
              </li>
              <li>
                <span class="f-title">OFFICE</span>
                <span class="f-txt">3rd floor, 8, Hasin 1-gil, Gunsan-si, Jeonbuk, ROK <br> 4th floor, 40, Hyoryeong-ro, Seocho-gu, Seoul, ROK</span>
              </li>
            </ul>
          </address>
        </li>

        <li :class="{ hidden: !showDetails }" class="transition-area">
          <div class="f-content">
            <span class="f-title f-tit-2">BUSINESS LICENSE</span>
            <span class="f-txt">509-86-02834</span>
            <span class="f-txt" @click="openPopup"><a href="#">Check Business Information</a></span>
          </div>
        </li>
      </ul>

      <div class="f-ul-m">
        <div class="f-logo">
          <figure><img src="@/assets/images/common/MIMIO_B.I.svg" alt="" style="width: 56px; height: 16px;"></figure>
        </div>
<!--        <div class="f-content">-->
<!--          <span class="f-title">Contact us and work together</span>-->
<!--          <span class="f-txt">+82-(0)507-1395-5634 | hello@article21.co.kr</span>-->
<!--        </div>-->
        <div class="f-content">
<!--          <span class="f-title">Terms of Use & Privacy Policy</span>-->
<!--          <span class="f-txt">+82-(0)10-2132-5634</span>-->
          <span class="f-txt">+82-(0)10-2132-5634 | hello@article21.co.kr</span>
          <span class="f-txt">Work Hours 10:00-18:00 Weekdays (Excluding 12:00-13:00)</span>
          <div class="f-link">
            <!--                    <span class="f-txt"><a href="/">1:1 Inquiry</a></span>-->
            <span class="f-txt"><a href="/terms">Terms of Use</a></span>
            <span class="f-txt"><a href="/privacy">Privacy Policy</a></span>
            <p class="f-detail" @click="toggleDetails"><span>MORE DETAILS</span><img src="@/assets/images/icon/ico_select_wh.svg" :class="{ 'rotate-180': isDetailsOpen }" alt=""></p>
          </div>
        </div>
        <div v-show="isDetailsOpen" class="f-content detail">
          <address>
            <ul class="f-info">
              <li>
                <span class="f-title">CEO</span>
                <span class="f-txt">Ahrum Oh</span>
              </li>
              <li>
                <span class="f-title">PIC</span>
                <span class="f-txt">Jihyeon Kim</span>
              </li>
              <li>
                <span class="f-title">OFFICE</span>
                <span class="f-txt">3rd floor, 8, Hasin 1-gil, Gunsan-si, Jeonbuk, ROK <br> 4th floor, 40, Hyoryeong-ro, Seocho-gu, Seoul, ROK</span>
              </li>
              <li>
                <span class="f-title">business</span>
                <span class="f-txt">509-86-02834 | 2023-전북군산-0606</span>
              </li>
              <li>
                <span class="f-title">license</span>
                <span class="f-txt" @click="openPopup"><a href="#">Check business information</a></span>
              </li>
              <li>
                <span class="f-title"></span>
                <span class="f-txt">© 2024. ARTICLE21 Corp. All rights reserved.</span>
              </li>
              <li>
                <span class="f-title"></span>
                <span class="to-homepage"><a href="https://article21.co.kr/" target="_blank" rel="noopener noreferrer">아티클21 홈페이지</a></span>
              </li>
            </ul>
          </address>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, nextTick } from 'vue';

// 상태 변수 설정 (isDetailsOpen을 ref로 관리)
const isDetailsOpen = ref(false);

// 토글 기능
const toggleDetails = () => {
  isDetailsOpen.value = !isDetailsOpen.value;

  nextTick(() => {
    if (isDetailsOpen.value) {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    }
  });
};

const showDetails = ref(false)
const toggleDetailsPc = () => {
  showDetails.value = !showDetails.value
}



const openPopup = () => {
  window.open("https://www.ftc.go.kr/bizCommPop.do?wrkr_no=5098602834", "bizCommPop", "width=750, height=700;");
}
const openInisisPopup = () => {
  window.open('https://mark.inicis.com/mark/popup_v3.php?mid=article266','mark','scrollbars=no,resizable=no,width=565,height=683');
}
const openEscrowPopup = () => {
  window.open('https://mark.inicis.com/mark/escrow_popup_v3.php?mid=article266','mark','scrollbars=no,resizable=no,width=565,height=683');
}

</script>

<style scoped>

footer .f-ul > li:first-child {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

footer .f-ul > li:first-child .to-homepage {
  width: 78px;
  height: 20px;
  font-weight: 500;
  font-size: 9px;
}

.transition-area {
  transition: opacity 0.3s ease;
  opacity: 1;
  visibility: visible;
  height: auto;
}

.hidden {
  opacity: 0;
  visibility: hidden;
  height: 0;
  overflow: hidden;
}

.to-homepage {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 93px;
  height: 20px;
  background: transparent;
  border: 0.5px solid #FFFFFF;
  border-radius: 25px;
  font-family: 'SUIT', Arial, sans-serif;
  font-weight: 400;
  font-size: 10px;
  line-height: 24px;
  text-transform: capitalize;
  color: #FFFFFF;
  margin-top: 5px;
}

.to-homepage a {
  color: #FFFFFF;
}

.f-content-sub-wrap {
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  margin-bottom: 5px;

}

.f-content-2 {
  margin-top: 21px;
  display: flex;
  flex-direction: row;
  column-gap: 12px;
}

.footer-link{
  width: 100px;
  height: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 0px;
  border: 0.5px solid #FFFFFF;
  border-radius: 17px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 275;
  font-size: 12px;
  line-height: 38px;
  text-align: center;
  color: #FFFFFF;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
}

.footer-link a{
  color: #FFFFFF;
}

.footer-link.active {
  background-color: white;
  color: #000; /* 필요 시 글자색도 조정 */
}
</style>
